import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-datetime-field',
  templateUrl: './datetime-field.component.html',
  styleUrls: ['./datetime-field.component.scss'],
})
export class DatetimeFieldComponent {
  @Input() form!: FormGroup;
  @Input() label!: string;
  @Input() minDate?: Date;
  @Input() maxDate?: Date;
  @Input() disabled: boolean = false;
  @Output() formChange = new EventEmitter<FormGroup>();

  get date() {
    return this.form.get('date') as FormControl;
  }
  get time() {
    return this.form.get('time') as FormControl;
  }

  onChange() {
    this.formChange.emit(this.form);
  }
}
